import { render, staticRenderFns } from "./dragAndDropField.vue?vue&type=template&id=20bac648"
import script from "./dragAndDropField.vue?vue&type=script&lang=js"
export * from "./dragAndDropField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports